<template>
  <div
    class="playerReview-grid-container"
    :style="`width: calc(100vw / ${nbOfPlayers});`"
  >
    <div
      :class="`playerReview-name ${player.isConnected ? '' : 'disconnected'}`"
    >
      <h2 :style="`width: calc(100vw / ${nbOfPlayers});`">{{ player.name }}</h2>
    </div>
    <div
      :class="`playerReview-avatar ${player.isConnected ? '' : 'disconnected'}`"
    >
      <img :src="avatars[player.avatar]" alt="avatar" />
    </div>
    <div class="playerReview-points">
      <h2>{{ player.points }}</h2>
    </div>
    <div class="playerReview-toAdd">
      <h3 v-if="player.pointsToAdd[0]">
        {{ `+${player.pointsToAdd[0]}: ${player.pointsToAdd[1]}` }}
      </h3>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "playerReview",
  props: {
    playerId: String
  },
  computed: {
    ...mapState("colyseus", ["playerById"]),
    ...mapState(["avatars"]),
    player() {
      return this.playerById[this.playerId];
    },
    nbOfPlayers() {
      return Object.keys(this.playerById).length;
    }
  }
};
</script>

<style lang="scss" scoped>
.playerReview-grid-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 0.5fr 1.2fr 0.4fr 1.4fr;
  gap: 1px 1px;
  grid-template-areas: "playerReview-name" "playerReview-avatar" "playerReview-points" "playerReview-toAdd";
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 800px) {
    width: 100% !important;
    grid-template-rows: 0.5fr 1.2fr 0.4fr 1.4fr;
  }
}

.playerReview-name {
  grid-area: playerReview-name;
}

h2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media only screen and (max-width: 800px) {
    width: 100% !important;
  }
}

.playerReview-avatar {
  grid-area: playerReview-avatar;
}

.playerReview-points {
  grid-area: playerReview-points;
}

.playerReview-toAdd {
  grid-area: playerReview-toAdd;
  color: green;
}

.playerReview-toAdd > h3 {
  font-size: 3vmin !important;
}

.playerReview-avatar > img {
  width: 7vw;
  @media only screen and (max-width: 800px) {
    width: 15vw;
  }
}
</style>
